import React                      from 'react';
import { useDispatch }            from 'react-redux';
import { CAB_TYPE_DETAIL_MODAL }  from '../../pages/SearchPage/redux/action-types';
import * as S                     from './CabTypeModalDetailsStyle';

const CabTypeModalDetails = ({item}) => {
  const {title = "", details = [], cta = "", img = ""} = item
  const dispatch = useDispatch()

  const handleMore = () => {
    dispatch({
      type                    : CAB_TYPE_DETAIL_MODAL,
      showCabTypeDetailsModal : false
    })
  }

  return (
    <>
      <S.Backdp onClick={handleMore}>
        &nbsp;
      </S.Backdp>
      <S.HourlyRentalsPop>
        <span className="close" onClick={handleMore}>&nbsp;</span>
        <div  className='inner'>
          <h2>{title}</h2>
          <div className='art'>
            <img src={img} loading='lazy' alt={title}/>
          </div>
          <ul>
            {details.map((detls, index) => (
              <li key={index}>
                {detls}
              </li>
            ))}
          </ul>     
          <button onClick={handleMore} className="gotBtn">{cta}</button>
        </div>
      </S.HourlyRentalsPop>
    </>
  );
}

export default CabTypeModalDetails;
